import React from "react"

import {
  UseProfileDeleteCodeOverlayViewModelProps,
  useProfileDeleteCodeOverlayViewModel
} from "./model/useProfileDeleteCodeOverlayViewModel"
import { ProfileDeleteCodeOverlayView } from "./ui/ProfileDeleteCodeOverlayView"

export const ProfileDeleteSubmitCodeOverlay = React.memo(
  (props: UseProfileDeleteCodeOverlayViewModelProps) => {
    return (
      <ProfileDeleteCodeOverlayView
        {...useProfileDeleteCodeOverlayViewModel(props)}
      />
    )
  }
)
